import NotFound from '@src/pages/NotFound';
import { createFileRoute } from '@tanstack/react-router';

import { loadClientGroupName } from '../clientTitle';
import { getLocalizedDynamicTitle } from '../title';

export const Route = createFileRoute('/_app/clients/groups/$groupId/')({
  loader: async ({ context, params }) => ({
    groupName: await loadClientGroupName(context.apiClient, params.groupId),
  }),
  head: ({ loaderData }) => ({
    meta: [
      {
        title: getLocalizedDynamicTitle(
          'clients.group_detail.page_title',
          'Client Group Detail',
          loaderData?.groupName ?? '',
        ),
      },
    ],
  }),
  // A group that does not exist or that the user may not view.
  notFoundComponent: NotFound,
});
